export * from './textConstant';

export const TABS_CONFIG = [
  {
    fcID: 0,
    id: 1,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 2,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 3,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 0,
    id: 4,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 5,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 6,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 0,
    id: 7,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 8,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 9,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 0,
    id: 10,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 11,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 12,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
];

export const EXTENDED_TABS_CONFIG = [
  {
    fcID: 0,
    id: 1,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 2,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 3,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 3,
    id: 4,
    logo: '/theme/img/Palette.svg',
    name: 'color',
  },
  {
    fcID: 4,
    id: 5,
    logo: '/theme/img/iconPattern.svg',
    name: 'pattern',
  },
  {
    fcID: 0,
    id: 6,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 7,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 8,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 3,
    id: 9,
    logo: '/theme/img/Palette.svg',
    name: 'color',
  },
  {
    fcID: 4,
    id: 10,
    logo: '/theme/img/button-icon/pattern.svg',
    name: 'pattern',
  },
  {
    fcID: 0,
    id: 11,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 12,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 13,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 3,
    id: 14,
    logo: '/theme/img/Palette.svg',
    name: 'color',
  },
  {
    fcID: 4,
    id: 15,
    logo: '/theme/img/button-icon/pattern.svg',
    name: 'pattern',
  },
  {
    fcID: 0,
    id: 16,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 17,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 18,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 3,
    id: 19,
    logo: '/theme/img/Palette.svg',
    name: 'color',
  },
  {
    fcID: 4,
    id: 20,
    logo: '/theme/img/button-icon/pattern.svg',
    name: 'pattern',
  },
  {
    fcID: 0,
    id: 21,
    logo: '/theme/img/iconLogo.svg',
    name: 'logo',
  },
  {
    fcID: 1,
    id: 22,
    logo: '/theme/img/iconText.svg',
    name: 'text',
  },
  {
    fcID: 2,
    id: 23,
    logo: '/theme/img/iconStyle.svg',
    name: 'style',
  },
  {
    fcID: 3,
    id: 24,
    logo: '/theme/img/Palette.svg',
    name: 'color',
  },
  {
    fcID: 4,
    id: 25,
    logo: '/theme/img/button-icon/pattern.svg',
    name: 'pattern',
  },
];

export const getTabsConfig = (fullCustom = false) => {
  const isFullCustom = fullCustom === true || fullCustom === 'true';
  return isFullCustom ? EXTENDED_TABS_CONFIG : TABS_CONFIG;
};
